export const nombreMax = (nbFichiers) => () => ({
  validator(_, value) {
    if (value && value.length > nbFichiers) {
      return Promise.reject(new Error(`Limité à ${nbFichiers} fichiers max`));
    }
    return Promise.resolve();
  },
});
